export const normalizePriceSearch = (value) => String(value || "").trim();

export const parseRonCents = (value) => {
  if (typeof value === "number") {
    return Number.isSafeInteger(Math.round(value * 100)) && Math.abs(value * 100 - Math.round(value * 100)) < 0.00001
      ? Math.round(value * 100)
      : null;
  }
  let raw = String(value ?? "").trim();
  if (/\s/.test(raw)) {
    if (!/^-?\d{1,3}(?:[ \u00a0\u202f]\d{3})+(?:[.,]\d{1,2})?$/.test(raw)) return null;
    raw = raw.replace(/[ \u00a0\u202f]/g, "");
  }
  if (!raw || !/^-?\d[\d.,]*$/.test(raw)) return null;
  let normalized = raw;
  if (/^-?\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(raw)) {
    normalized = raw.replace(/\./g, "").replace(",", ".");
  } else if (/^-?\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?$/.test(raw)) {
    normalized = raw.replace(/,/g, "");
  } else if (/^-?\d+(?:[.,]\d{1,2})?$/.test(raw)) {
    normalized = raw.replace(",", ".");
  } else {
    return null;
  }
  const cents = Math.round(Number(normalized) * 100);
  return Number.isSafeInteger(cents) ? cents : null;
};

export const formatRon = (value) => {
  const cents = parseRonCents(value);
  return cents === null || cents <= 0
    ? "Indisponibilă"
    : new Intl.NumberFormat("ro-RO", {
        style: "currency",
        currency: "RON",
      }).format(cents / 100);
};

export const validatePriceReduction = (currentPrice, proposedPrice) => {
  const currentCents = parseRonCents(currentPrice);
  const proposedCents = parseRonCents(proposedPrice);
  let message = "";
  if (currentCents === null || currentCents <= 0) {
    message = "Suma actuală nu este disponibilă. Reîncarcă datele produsului.";
  } else if (!String(proposedPrice ?? "").trim()) {
    message = "Introdu noua sumă agreată telefonic cu vânzătorul.";
  } else if (proposedCents === null || proposedCents <= 0) {
    message = "Introdu o sumă validă, mai mare decât zero, cu cel mult două zecimale.";
  } else if (proposedCents >= currentCents) {
    message = "Noua sumă trebuie să fie mai mică decât suma actuală.";
  }
  return {
    isValid: !message,
    message,
    currentCents,
    proposedCents,
    difference: !message ? (currentCents - proposedCents) / 100 : null,
  };
};

export const priceReductionErrorMessage = (error, fallback) =>
  error.response?.data?.message || fallback;

export const getExpirationInfo = (value, now = new Date()) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/);
  const missing = { date: "—", label: "Fără dată", color: "default" };
  if (!match) return missing;
  const [year, month, day] = match.slice(1).map(Number);
  const timestamp = Date.UTC(year, month - 1, day);
  const date = new Date(timestamp);
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return missing;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const days = (timestamp - today) / 86400000;
  return {
    date: date.toLocaleDateString("ro-RO", { timeZone: "UTC" }),
    label: days < 0 ? "Expirat" : days === 0 ? "Astăzi" : days <= 5 ? "Curând" : "Activ",
    color: days < 0 ? "error" : days === 0 ? "warning" : days <= 5 ? "success" : "info",
  };
};
